// extracted by mini-css-extract-plugin
export default {"query":"searchForm_query__sKQCt","submitBtn":"searchForm_submitBtn__4p8VE"};